import React, { useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react'
import { FormattedMessage, useIntl } from "react-intl";
import { useRef } from "react";
import ProductTransitonModal from "../transition-modal";
import { useState } from 'react';
import ShippingInfo from "../../../../module/shipping-info";
import { fetchGetMessage } from "../../../../../../../../api";
import { QuickShippingTxt } from "../quick-shipping";

const ShippingInfoModalItem = props =>{
    const { productId } = props;
    const [data,setData] = useState(null);

    useEffect(async () =>{
        let response = await fetchGetMessage("M1292");
        if(response?.code === 200){
            setData(response?.result);
        }
    },[]);

    return <div>
        <div className={classes.Title}><FormattedMessage id="shipping_info" defaultMessage="Shipping Info" /></div>

        <div className={classes.Bd}>
            <ShippingInfo productId={productId} />
        </div>

        {
            data?.enabled && data?.message && <div className={classes.Message} dangerouslySetInnerHTML={{__html:data.message}}></div>
        }
        
        <div className={classes.Message2}><FormattedMessage id="receiving_time" defaultMessage="Receiving time" /> = <FormattedMessage id="precessing_time" defaultMessage="Processing time" /> + <FormattedMessage id="shipping_time" defaultMessage="Shipping Time" /></div>

        <div className={classes.Message2}>
            <a style={{color:"#666",textDecoration:"underline"}} href={`/policy/shipping-policy`}><FormattedMessage id="learn_more" defaultMessage="Learn More" /></a>
        </div>
    </div>
}

const ShippingInfoModal = props =>{

    return <ProductTransitonModal {...props} className={classes.ShippingInfoModal}>
        <ShippingInfoModalItem {...props} />
    </ProductTransitonModal>
}

const ReturnShippingModal = props =>{
    const { returnMessage } = props;

    return <ProductTransitonModal {...props} className={classes.ReturnShippingModal}>
        <div> 
            <div className={classes.Title}><FormattedMessage id="easy_return" defaultMessage="Easy Return" /></div>
            
            <div className={classes.Content} dangerouslySetInnerHTML={{__html:returnMessage}}></div>

            <div className={classes.MoreLink}>
                <a href={`/policy/return-policy`}><FormattedMessage id="learn_more" defaultMessage="Learn More" /></a>
            </div>
        </div>
    </ProductTransitonModal>
}


const ProductShippingInfo = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { productVO, selectedVariant, isBeautyMakeup, seelctedProduct } = productHooks;
    const [returnShow,setReturnShow] = useState(false);
    const [shippingShow,setShippingShow] = useState(false);

    const Intl = useIntl();

    // 是否为海外仓商品
    const isDisabled = selectedVariant?.domesticDelivery.enabled;

    const shippingI18 = Intl.formatMessage(
        { id: 'us_address_deliverd' },
        { value: `<span style="font-family: Roboto-Medium;color:#222222;">${Intl.formatMessage({ id: 'us_address' })}</span>` }
    );

    return <div className={classes.ProductShippingInfo}>
        <div className={classes.ShippingTo}>
            <div className={classes.LeftContainer}>
                <Iconfont className={classes.CartIcon}>&#xe765;</Iconfont>
                {
                    productVO?.freeShippingTitle && <span className={classes.FreeShippingTitle}>
                        {productVO?.freeShippingTitle}
                    </span>
                }

                <Iconfont className={classes.Question} onClick={()=>setShippingShow(true)}>&#xe6b8;</Iconfont>
            </div>

            <div className={classes.RightContainer} style={{display:`${(productVO?.isLogisticsInCountryIsNotSupported || isDisabled)?"none":"block"}`}}>
                <Iconfont id="shipping-info-prev">&#xe693;</Iconfont>
                <Iconfont id="shipping-info-next">&#xe694;</Iconfont>
            </div>
        </div>

        <div className={classes.ShippingInfoContainer}>
            {
                productVO?.isLogisticsInCountryIsNotSupported ? (
                    <div className={classes.BeautyNot}>
                        <span><FormattedMessage id="ship_current_address" defaultMessage="This item cannot ship to current address" /></span>
                    </div>
                ) : (
                    isDisabled ? <React.Fragment>
                        {
                            // 如果存在海外仓产品则提示 quick shipping
                            productVO?.domesticDeliveryShippingInfo?.description &&
                            <QuickShippingTxt clickHandle={()=>setShippingShow(true)} htmlValue={productVO?.domesticDeliveryShippingInfo?.description}/>
                        }
                        {
                            productVO?.domesticDeliveryShippingInfo?.shippingInfoItems?.map((shipping,index) =>{
                                return <div className={classes.ShippingInfoItemSlide} key={index}>
                                    <div className={classes.ShippingInfoItem}>
                                    {
                                        shipping?.shippingMsg && <div className={classes.Title1}>
                                            <span dangerouslySetInnerHTML={{__html:shipping.shippingMsg}}></span>
                                        </div>
                                    }
                                    {
                                        shipping?.estimatedArrivalTime && <div className={classes.Title2}>
                                            <span dangerouslySetInnerHTML={{__html:shippingI18}}></span>
                                            <span style={{color:"#e64545"}}> {shipping.estimatedArrivalTime}</span>
                                        </div>
                                    }
                                    </div>
                                </div>
                            })
                        }
                    </React.Fragment> : (
                        productVO?.shippingInfo?.shippingInfoItems?.length > 0 && <>
                            <Swiper 
                                navigation={{
                                    prevEl: '#shipping-info-prev',
                                    nextEl: '#shipping-info-next',
                                }} 
                                modules={[Navigation]}
                                spaceBetween={8}
                                slidesPerView="auto"
                            >
                            {
                                productVO?.shippingInfo?.shippingInfoItems.map((shipping,index) =>{
                                    return <SwiperSlide key={index} className={classes.ShippingInfoItemSlide}>
                                        <div className={classes.ShippingInfoItem}>
                                            {
                                                shipping?.shippingMsg && <div className={classes.Title1} style={{fontSize:12}}>
                                                    <span>{shipping.shippingMsg}</span>
                                                </div>
                                            }
                                            {
                                                shipping?.estimatedArrivalTime && <div className={classes.Title2} style={{fontSize:12}}>
                                                    <span><FormattedMessage id="estimated_time" defaultMessage="Estimated Time of Arrival" />:</span>
                                                    <span>{shipping.estimatedArrivalTime}</span>
                                                </div>
                                            }
                                        </div>
                                    </SwiperSlide>
                                })
                            }
                            </Swiper>
                        </>
                    )
                )
            }
            
        </div>

        {
            productVO?.returnInfo && <div className={classes.EasyReturnContainer}>
                <div className={classes.LeftContainer}>
                    <Iconfont>&#xe6aa;</Iconfont>
                </div>

                <div className={classes.RightContainer}>
                    <p className={classes.Title1}>
                        <span className={classes.FreeShippingTitle}>{productVO.returnInfo?.title}</span>
                        <Iconfont className={classes.Question} onClick={()=>setReturnShow(true)}>&#xe6b8;</Iconfont>
                    </p>
                    {
                        productVO.returnInfo?.message && <p className={classes.Title2}>
                            {productVO.returnInfo.message}
                        </p>
                    }
                </div>
            </div>
        }

        <ShippingInfoModal 
            show={shippingShow} 
            productId={seelctedProduct?.id} 
            onClose={()=>setShippingShow(false)}
        />

        <ReturnShippingModal returnMessage={productVO?.returnPolicy} show={returnShow} onClose={()=>setReturnShow(false)} />
    </div>
}

export default ProductShippingInfo;